// extracted by mini-css-extract-plugin
export default {"flexWrap":"VdAccessModal_flexWrap_OXKnC","contentStrong":"VdAccessModal_contentStrong_HcQQD","content":"VdAccessModal_content_UhsOI"};